import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ArrowUpRightIcon, MapIcon, MapPinIcon, TrophyIcon } from 'lucide-react';
import { WeekendSchedule } from '../components/WeekendSchedule';
import { ArticleCard } from '../components/ArticleCard';
import { BuilderLogoGrid } from '../components/BuilderLogoGrid';
import { SponsorStrip } from '../components/SponsorStrip';
import { aboutText, contact, eventYear, homesSince1996, links, magazine, testimonial } from '../data/event';
import { articles } from '../data/articles';
import { featuredBuilders } from '../data/builders';
import { presentingSponsor } from '../data/sponsors';
import { covers, tourMap } from '../data/magazine';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/18dc5ec8-df3e-47d1-8f7d-844f0ddde8c4.jpg';
export function Home() {
  const [showFullQuote, setShowFullQuote] = useState(false);
  return <>
      {/* Hero */}
      <section className="relative isolate overflow-hidden bg-navy-dark" data-id="element-217" data-mp="3oyq9ll47mg9a">
        <img src={HERO_IMAGE} alt="" className="absolute inset-0 -z-10 h-full w-full object-cover" data-id="element-218" data-mp="30w9n136vwozp" />
        <div className="absolute inset-0 -z-10 bg-navy-dark/70" aria-hidden="true" data-id="element-219" data-mp="2vy85imp3wxqc" />
        <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 md:py-24 lg:grid-cols-12 lg:items-center lg:px-8" data-id="element-220" data-mp="2qxak818svnkm">
          <div className="lg:col-span-7" data-id="element-221" data-mp="2mwqq76jix02p">
            <p className="text-base text-white/85" data-id="element-222" data-mp="2hxnl5m3jmtuq">
              Presented by <span className="font-semibold text-white" data-id="element-223" data-mp="2i009cgzwa0g8">{presentingSponsor.name}</span>
            </p>
            <h1 className="mt-3 font-display text-5xl font-bold uppercase leading-[0.95] text-white sm:text-6xl lg:text-7xl" data-id="element-224" data-mp="2d546smx17uov">
              <span className="text-orange" data-id="element-225" data-mp="239axrdiiujbu">{eventYear}</span> Builders’ Showcase of Homes
            </h1>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/85" data-id="element-226" data-mp="1z7xqcyzs682t">
              Walk through professionally designed model and custom homes across Cape Coral — from attainably priced to
              luxury — over three weekends in January and February.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-227" data-mp="1omc7vmzbbwz8">
              <Link to="/model-homes" className="inline-flex items-center justify-center gap-2 rounded-md bg-orange-deep px-6 py-3.5 text-base font-semibold text-white transition-colors duration-150 hover:bg-orange-deeper" data-id="element-228" data-mp="1onnbnmsrd4qc">
                <MapIcon className="h-5 w-5" aria-hidden="true" data-id="element-229" data-mp="23c9s5ru4g2j5" />
                View the tour map
              </Link>
              <Link to="/magazine" className="inline-flex items-center justify-center rounded-md border border-white/40 px-6 py-3.5 text-base font-semibold text-white transition-colors duration-150 hover:bg-white/10" data-id="element-230" data-mp="289i8rnzmfyia">
                Browse the magazine
              </Link>
            </div>
            <p className="mt-8 text-sm text-white/75" data-id="element-231" data-mp="2r0j5e5d9rhyo">Hosted by the Cape Coral Construction Industry Association</p>
          </div>

          <div className="lg:col-span-5" data-id="element-232" data-mp="fkseq0agtrjq">
            <div className="rounded-2xl bg-white p-6 shadow-xl sm:p-8" data-id="element-233" data-mp="fjpnfr98dn3a">
              <h2 className="font-display text-sm font-semibold uppercase tracking-wider text-muted" data-id="element-234" data-mp="am7psx0nyual">When to visit</h2>
              <div className="mt-5" data-id="element-235" data-mp="og8f705q74ya">
                <WeekendSchedule data-id="element-236" data-mp="kc0o4wbspcww" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About */}
      <section className="mx-auto grid max-w-7xl gap-12 px-5 py-20 lg:grid-cols-12 lg:gap-16 lg:px-8 lg:py-28" data-id="element-237" data-mp="3st597d7ec064">
        <div className="lg:col-span-7" data-id="element-238" data-mp="3nv3q4s9z00un">
          <h2 className="font-display text-4xl font-bold uppercase leading-tight text-navy md:text-5xl" data-id="element-239" data-mp="5neb519n4x8u">
            About the Showcase of Homes
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-240" data-mp="n8cv28v8chs">
            {aboutText} This premier event provides a{' '}
            <a href={links.gatewayPdf} target="_blank" rel="noreferrer" className="font-semibold text-navy underline underline-offset-4 hover:text-orange-deep" data-id="element-241" data-mp="1c3qc1a3ukt84">
              gateway to Southwest Florida dream homes
            </a>
            .
          </p>
        </div>
        <dl className="grid grid-cols-3 gap-6 self-center border-t border-line pt-8 lg:col-span-5 lg:grid-cols-1 lg:gap-8 lg:border-l lg:border-t-0 lg:pl-12 lg:pt-0" data-id="element-242" data-mp="2cd85u9r2t4l9">
          <div data-id="element-243" data-mp="2mc72sv2hbbsf">
            <dt className="text-sm text-muted" data-id="element-244" data-mp="2mcqmohbowa93">Homes featured on tour</dt>
            <dd className="font-display text-5xl font-bold text-orange-deep lg:text-6xl" data-id="element-245" data-mp="2qdiur78ts93s">{homesSince1996}</dd>
          </div>
          <div data-id="element-246" data-mp="2va9b7vojl6pq">
            <dt className="text-sm text-muted" data-id="element-247" data-mp="2va0v7ux4hlab">Hosted since</dt>
            <dd className="font-display text-4xl font-bold text-ink" data-id="element-248" data-mp="303loj9nrtr36">1996</dd>
          </div>
          <div data-id="element-249" data-mp="351wzxotps9ni">
            <dt className="text-sm text-muted" data-id="element-250" data-mp="350c47vvnyko2">Weekends</dt>
            <dd className="font-display text-4xl font-bold text-ink" data-id="element-251" data-mp="3a103t5xyk9tw">3</dd>
          </div>
        </dl>
      </section>

      {/* Tour map + vote */}
      <section className="bg-canvas py-20 lg:py-24" data-id="element-252" data-mp="3e2v0ty8uw11v">
        <div className="mx-auto grid max-w-7xl gap-10 px-5 lg:grid-cols-12 lg:items-center lg:px-8" data-id="element-253" data-mp="12fhskzz9h14w">
          <Link to="/model-homes" className="group block overflow-hidden rounded-2xl border border-line bg-white lg:col-span-7" data-id="element-254" data-mp="ycv7dhx3iego">
            <img src={tourMap.src} alt={tourMap.alt} className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]" loading="lazy" data-id="element-255" data-mp="tg4u12codwyy" />
          </Link>
          <div className="lg:col-span-5" data-id="element-256" data-mp="1h57c2bb81rtz">
            <h2 className="font-display text-4xl font-bold uppercase text-navy" data-id="element-257" data-mp="1cd61quxm6b6l">Find every model home</h2>
            <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-258" data-mp="17e2xvdtdeb07">
              The official tour map and entry legend show where each home is across Cape Coral, plus the builder behind it.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row lg:flex-col xl:flex-row" data-id="element-259" data-mp="20309iy32t9jz">
              <Link to="/model-homes" className="inline-flex items-center justify-center gap-2 rounded-md bg-navy px-6 py-3.5 font-semibold text-white transition-colors duration-150 hover:bg-navy-dark" data-id="element-260" data-mp="3uauea43o57k8">
                Open tour map
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-261" data-mp="3kiyemolxp9dw" />
              </Link>
              <a href={links.vote} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 rounded-md border border-line bg-white px-6 py-3.5 font-semibold text-navy transition-colors duration-150 hover:border-navy" data-id="element-262" data-mp="3phrh7lzonfza">
                <TrophyIcon className="h-4 w-4 text-orange-deep" aria-hidden="true" data-id="element-263" data-mp="36kqey8xijtz1" />
                Pick your favorite model
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Magazine */}
      <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-24" data-id="element-264" data-mp="14slkoqsjkkl5">
        <div className="grid gap-10 rounded-2xl bg-navy p-8 text-white md:p-12 lg:grid-cols-12 lg:items-center" data-id="element-265" data-mp="1ex241u58cjtp">
          <div className="lg:col-span-5" data-id="element-266" data-mp="19za207avfhbs">
            <h2 className="font-display text-4xl font-bold uppercase" data-id="element-267" data-mp="19we24dfgqikp">The {eventYear} Showcase Magazine</h2>
            <p className="mt-4 text-lg leading-relaxed text-white/85" data-id="element-268" data-mp="1nrq7rfv5ptge">{magazine.note}</p>
            <p className="mt-6 flex gap-2 text-sm text-white/85" data-id="element-269" data-mp="1ix2ez4t4ecw0">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-orange" aria-hidden="true" data-id="element-270" data-mp="1xmrvq8dp4phe" />
              <span data-id="element-271" data-mp="1snx54k9hlwmq">Hard copies at the CCCIA office from {magazine.pickupDate} · {contact.street}</span>
            </p>
            <Link to="/magazine" className="mt-8 inline-flex items-center gap-2 rounded-md bg-orange-deep px-6 py-3.5 font-semibold text-white transition-colors duration-150 hover:bg-orange-deeper" data-id="element-272" data-mp="26o7x5qmj9h9h">
              Read it online
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-273" data-mp="89wu9ymr4dx6" />
            </Link>
          </div>
          <ul className="grid grid-cols-3 gap-3 sm:gap-5 lg:col-span-7" data-id="element-274" data-mp="wt0eclivepry">
            {covers.map(c => <li key={c.src} data-id="element-275" data-mp="11rv5qbuwlmno">
                <img src={c.src} alt={c.alt} className="aspect-[791/1024] w-full rounded-md object-cover shadow-xl" loading="lazy" data-id="element-276" data-mp="11r1twwh386yo" />
                <p className="mt-2 text-xs text-white/75" data-id="element-277" data-mp="1al84vvjk9ki7">{c.caption}</p>
              </li>)}
          </ul>
        </div>
      </section>

      {/* Testimonial */}
      <section className="border-y border-line bg-white" data-id="element-278" data-mp="dxk34o3t44kt">
        <div className="mx-auto max-w-4xl px-5 py-20 text-center lg:py-24" data-id="element-279" data-mp="iv3g7korqbb6">
          <blockquote data-id="element-280" data-mp="mvm8tgyhjlef">
            <p className="text-2xl font-medium leading-relaxed text-ink md:text-3xl" data-id="element-281" data-mp="mv46c2l8cay2">“{testimonial.quote}”</p>
            {showFullQuote && <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-282" data-mp="rsvvwpyejkz3">{testimonial.more}</p>}
            <footer className="mt-8 flex flex-col items-center" data-id="element-283" data-mp="1yastov2ebbze">
              <img src={testimonial.logo} alt="Coastal Craft Homes logo" className="h-12 w-auto object-contain" loading="lazy" data-id="element-284" data-mp="2394354os3kh3" />
              <p className="mt-4 font-semibold text-ink" data-id="element-285" data-mp="2ddan5tuj807a">{testimonial.name}</p>
              <p className="text-sm text-muted" data-id="element-286" data-mp="28gagphtrsvfn">{testimonial.role}</p>
            </footer>
          </blockquote>
          <button type="button" onClick={() => setShowFullQuote(v => !v)} aria-expanded={showFullQuote} className="mt-4 text-sm font-semibold text-orange-deep hover:text-orange-deeper" data-id="element-287" data-mp="23mptmktptlv8">
            {showFullQuote ? 'Show less' : 'Read full testimonial'}
          </button>
        </div>
      </section>

      {/* Builders */}
      <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8" data-id="element-288" data-mp="1kq6glkfsjdte">
        <div className="flex flex-col justify-between gap-2 sm:flex-row sm:items-end" data-id="element-289" data-mp="1gobfoh1rv2g5">
          <h2 className="font-display text-4xl font-bold uppercase text-navy" data-id="element-290" data-mp="3f360vqv48w70">{eventYear} Featured Builders</h2>
          <a href={links.builderRegistration} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 font-semibold text-orange-deep hover:text-orange-deeper" data-id="element-291" data-mp="3b1b2au4kkwwx">
            Builder registration
            <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-292" data-mp="8pccnbjab7j7" />
          </a>
        </div>
        <div className="mt-8" data-id="element-293" data-mp="mkerwpa0u98o">
          <BuilderLogoGrid builders={featuredBuilders} data-id="element-294" data-mp="hn6c2vccihal" />
        </div>
      </section>

      {/* Articles */}
      <section className="bg-canvas py-20 lg:py-24" data-id="element-295" data-mp="3q2q1fj9wbfkd">
        <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-296" data-mp="3q152zikgnch8">
          <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end" data-id="element-297" data-mp="3l5pruydu7uoi">
            <h2 className="font-display text-4xl font-bold uppercase text-navy" data-id="element-298" data-mp="3oygoruyjo1j">Featured articles</h2>
            <Link to="/articles" className="inline-flex items-center gap-2 font-semibold text-orange-deep hover:text-orange-deeper" data-id="element-299" data-mp="3v1jcl51pmuhd">
              All articles
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-300" data-mp="32dwyh2uuw7g9" />
            </Link>
          </div>
          <div className="mt-10 grid gap-10 md:grid-cols-3" data-id="element-301" data-mp="1hw4mh1xkag19">
            {articles.slice(0, 3).map(a => <ArticleCard key={a.id} article={a} data-id="element-302" data-mp="1mn4je76oky3r" />)}
          </div>
        </div>
      </section>

      {/* Sponsors */}
      <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8" data-id="element-303" data-mp="18whluicnpe99">
        <SponsorStrip data-id="element-304" data-mp="1cw9vyzhp7sgq" />
      </section>
    </>;
}